export default function getVenueName(venue, lang) {
    //console.log('getVenueName');
    //console.log(venue);
    //console.log(lang);

    if (typeof venue['nametrad'] === 'object') {
        //console.log(111111);
        //console.log(lang);

        if (typeof venue['nametrad'][lang] === 'object') {
            if (typeof venue['nametrad'][lang]['val'] === 'string') {
                return venue['nametrad'][lang]['val'];
            }
        }
    }
    return 'unknown';
}
